module.exports = __webpack_public_path__ + "img/machineThre-img4.180e9188.jpg";